import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    main: {
      '& .MuiPaper-root': {
        width: 407,
        minHeight: 210,
      },
      '& .MuiDialogTitle-root': {
        textAlign: 'center',

        '& h3': {
          fontSize: '2.2rem',
        },
      },
      '& .MuiDialogContent-root, .MuiDialogActions-root': {
        backgroundColor: '#F9F9FB',
      },
      '& .MuiDialogContent-root': {
        padding: theme.spacing(2.5, 5, 1),

        '& p': {
          marginBottom: '1rem',
        },
        '& .MuiListItemIcon-root': {
          minWidth: 15,
          fontSize: '2.2rem',
          lineHeight: '1rem',
          color: 'inherit',
        },
        '& .MuiListItemText-primary': {
          fontSize: '1.2rem',
        },
        '& .MuiList-padding, .MuiListItem-root': {
          padding: 0,
        },
      },
    },
    error: {
      '& .MuiDialogTitle-root': {
        color: theme.palette.error.main,

        '& h3': {
          color: theme.palette.error.main,
        },
      },
    },
    success: {
      '& .MuiDialogTitle-root': {
        color: '#23AA50',

        '& h3': {
          color: '#23AA50',
        },
      },
    },
    warning: {
      '& .MuiDialogTitle-root': {
        color: '#FAAF32',

        '& h3': {
          color: '#FAAF32',
        },
      },
    },

    dialogActions: {
      justifyContent: 'center',
      '& > button': {
        minWidth: '11rem',
        width: 'auto',
        height: 'auto',
        padding: '1rem',
      },
    },
  }),
)
